require('./bootstrap');
require('./search');
require('./redirectModal');

function checkArticleNavigator() {
    var $articleNavigator = document.getElementById('explore-articles-navigator');
    var $index = document.getElementById('cancer-index');

    if(!$articleNavigator.classList.contains('show')){
        $articleNavigator.classList.add('show');
        $articleNavigator.style.marginBottom = "-" + $articleNavigator.offsetHeight + "px";
        $index.classList.add('navigator-open');
    }
    else{
        $articleNavigator.classList.remove('show');
        $index.classList.remove('navigator-open');
    }
}
function checkCloseArticleNavigator() {
    var $articleNavigator = document.getElementById('explore-articles-navigator');
    var $index = document.getElementById('cancer-index');

    if($articleNavigator.classList.contains('show')){
        $articleNavigator.classList.remove('show');
        $index.classList.remove('navigator-open');
    }
}

$(document).ready(function() {
    $(".hamburger").click(function() {
        $(this).toggleClass("is-active");
        $(".mainnav-center").toggleClass("show");
        $("body").toggleClass("nav-open");
    });

    $(".toggle-mobile-dropdown").click(function() {
        $(this).parent().next(".nav-dropdown-big").slideToggle();
        $(this).toggleClass('toggled');
    });

    $("#explore-articles-cta").click(function() {
        checkArticleNavigator();
    });

    $("body").click(function(event) {
        if(event.target.id == null || event.target.id !== 'explore-articles-cta'){
            if(document.getElementById('explore-articles-navigator')!=null){
                if(!(event.target.id === $("#explore-articles-navigator") || document.getElementById('explore-articles-navigator').contains(event.target))){
                    checkCloseArticleNavigator(); //hide article navigator if clicked anywhere
                }
            }
        }
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > 5) {
            $("#mainnav").addClass("scrolled");
        } else {
            $("#mainnav").removeClass("scrolled");
        }
    });

    $(".component-article-jump-to-link").click(function(event) {
        event.preventDefault();

        var targetId = $(this).attr("href");
        if (targetId && targetId.startsWith("#")) {
            var $target = $(targetId);

            if ($target.length) {
                var navHeight = $("#mainnav").outerHeight() || 0;
                var targetPosition = $target.offset().top - navHeight - 20;

                $("html, body").animate({
                    scrollTop: targetPosition
                }, 250);
            }
        }
    });

});
